export const DEFAULT_ECOMMERCE_PERIOD = '30d';
export const ECOMMERCE_PERIODS = ['7d', '14d', '30d', '90d', '180d', '365d'];

/**
 * The brand logo arrives as a Python dict serialized to a string
 * (`{'url': ['https://...'], 'thumbnail_url': None, ...}`), not as JSON,
 * so the first entry of its `url` list is pulled out with a pattern.
 * A plain URL string is passed through unchanged.
 */
const LOGO_URL_PATTERN = /'url':\s*\[\s*'([^']+)'/;

export const getBrandLogoUrl = (logo) => {
  if (!logo) return '';
  if (typeof logo === 'object') return logo.url?.[0] || '';
  if (logo.startsWith('http')) return logo;
  return logo.match(LOGO_URL_PATTERN)?.[1] || '';
};

export const getRatingObject = (rating) => ({
  rate: rating.rate,
  maximumRate: rating.maximum_rate || 5,
});
